const contenedor = document.getElementById('contenedor');
const tabla = document.getElementById('tabla');
const btn_abrir = document.getElementById('btn-abrir');
const btn_cerrar = document.getElementById('btn-cerrar');
const contenido = document.getElementById('contenido');
const imagen_banner = document.getElementById('imagen-banner');
//tabla.style.display = 'none';
//btn_cerrar.style.display = 'none';

if (screen.width <= 700) {
    function abrir() {
        tabla.style.display = 'block';     	
        btn_abrir.style.display = 'none';
        btn_cerrar.style.display = 'block';
    }

    function cerrar() {
        tabla.style.display = 'none';
        tabla.style.transition = 'all .5s ease-in-out';
        btn_cerrar.style.display = 'none';
        btn_abrir.style.display = 'none';
    }
}

function abrir() {  
    imagen_banner.style.width = '90%';
    imagen_banner.style.height = '550px';
    imagen_banner.style.objectFit = 'cover';
    tabla.style.display = 'block';
  	contenido.style.width = '200%';
    tabla.style.width = '100%';
    btn_abrir.style.display = 'none';
    btn_cerrar.style.display = 'block';
    contenedor.style.display = 'flex';

}

function cerrar() {
    imagen_banner.style.width = '100%';
    imagen_banner.style.height = 'auto';
    tabla.style.display = 'none';
    btn_cerrar.style.display = 'none';
    btn_abrir.style.display = 'none';
    contenedor.style.display = 'block';
}